export const formatPrice = (value = 0, currency = 'RUB', styled = true) =>
  new Intl.NumberFormat('ru', {
    style: styled ? 'currency' : undefined,
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value)

export default formatPrice
